import isNote from 'app/forms/validations/isNote';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const CONTACT_DETAIL_FORM = 'contactDetail-form';

const { note } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	note,
	// ids for output fields
	noteFullName: 'noteFullName',
	noteDateCreated: 'noteDateCreated',
};

export default () => ({
	[FIELDS.note]: {
		deepPath: [FIELDS.note],
		validations: [isNote()],
	},
});
